<template>
  <v-layout justify-center class="white">
      <v-card px-0 mx-0>
        <v-card-text px-0 mx-0>
          <v-data-table
            :headers="boothHeaders"
            :items="rows"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.id }}</td>
              <td class="text-xs-center">{{ props.item.formattedDate }}</td>
              <td class="text-xs-center">{{ props.item.type }}</td>
              <td v-if="props.item.status === 'Void'" class="text-xs-left">** VOID **</td>
              <td v-else-if="props.item.type === 'Payment'" class="text-xs-left">{{ props.item.description }}</td>
              <td v-else class="text-xs-left">
                <div v-for="item in props.item.VendorAccountingDetails" :key="item">{{ item.description }}</div>
              </td>
              <td v-if="props.item.type === 'Payment'" class="text-xs-right red--text">{{ props.item.amountDisplay }}</td>
              <td v-else class="text-xs-right">{{ props.item.amountDisplay }}</td>
              <td v-if="props.item.type === 'Payment' && props.item.status === 'Void'" class="justify-center layout px-0">
                <v-icon @click="voidPayment(props.item, 'Open')" color="red">block</v-icon>
              </td>
              <td v-else-if="props.item.type === 'Payment'" class="justify-center layout px-0">
                <v-icon @click="voidPayment(props.item, 'Void')" color="green">check</v-icon>
              </td>
              <td v-else class="justify-center layout px-0">
                <v-icon @click="editItem(props.item)" color="blue">edit</v-icon>
              </td>
            </template>
            <template v-slot:footer>
              <td class="text-xs-right" :colspan="boothHeaders.length - 2">
                <strong>Total</strong>
              </td>
              <td v-if="grandTotal < 0" class="text-xs-right red--text">{{ grandTotalDisplay }}</td>
              <td  v-else class="text-xs-right">{{ grandTotalDisplay }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" @click="newItem">New Invoice</v-btn>
          <v-btn color="primary" @click="newPayment">New Payment</v-btn>
          <v-btn color="primary" @click="sendStatement">Email Statement</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newItem">Add</v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog v-model="dialogPayment" max-width="500px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThisEval">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Payment</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="savePayment">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  <v-select
                    v-model="evalItem.paymentType"
                    :items="paymentList"
                    item-text="name"
                    item-value="id"
                    label="Payment Type"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <strong>Amount Due {{ grandTotalDisplay }}</strong>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu1"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="formattedDate"
                      label="Date"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="evalItem.date"
                      no-title
                      @input="menu1 = false"
                      @change="formattedDate = formatDate(evalItem.date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="evalItem.paymentMode"
                    :items="paymentMode"
                    item-text="name"
                    item-value="id"
                    label="Payment Mode"
                  ></v-select>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs12>
                  <v-text-field
                    v-model="evalItem.cardNumber"
                    @keyup.enter="save"
                    label="Card #"
                    mask="credit-card"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs12>
                  <v-text-field
                    v-model="evalItem.cardName"
                    @keyup.enter="save"
                    label="Card Nane"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs4>
                  <v-text-field
                    v-model="evalItem.cardExpire"
                    @keyup.enter="save"
                    label="Expire Date"
                    mask="##/##"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs5></v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Credit Card'" xs3>
                  <v-text-field
                    v-model="evalItem.cardCvv"
                    @keyup.enter="save"
                    label="CVV"
                    mask="####"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Check'" xs12>
                  <v-text-field
                    v-model="evalItem.cardNumber"
                    @keyup.enter="save"
                    label="Check #"
                  ></v-text-field>
                </v-flex>
                <v-flex xs8></v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs4>
                  <v-text-field
                    v-model="evalItem.amount"
                    @keyup.enter="save"
                    label="Amount"
                    prefix="$"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs12>
                  <v-text-field
                    v-model="evalItem.notes"
                    @keyup.enter="save"
                    label="Notes"
                  ></v-text-field>
                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs12 sm3>
                  <v-checkbox
                    v-model="evalItem.emailReceipt"
                    label="Email Receipt"
                  ></v-checkbox>

                </v-flex>
                <v-flex v-if="evalItem.paymentMode === 'Cash' || evalItem.paymentMode === 'Check' || evalItem.paymentMode === 'Credit Card'" xs12 sm9>
                  <v-text-field
                    v-model="evalItem.email"
                    @keyup.enter="save"
                    label="Email Address"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogInvoice" max-width="500px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThisEval">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Invoice</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="save">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs6>
                  Invoice No. {{ evalItem.id }}
                </v-flex>
                <v-flex xs6>
                  <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formattedDate"
                    label="Date"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="evalItem.date"
                    no-title
                    @input="menu1 = false"
                    @change="formattedDate = formatDate(evalItem.date)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="evalItem.name"
                  @keyup.enter="save"
                  label="Company Name"
                  :rules="[v => !!v || 'Lasty Name is required']"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="evalItem.address"
                  @keyup.enter="save"
                  label="Address"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout wrap>
                  <v-flex xs10 md5>
                    <v-text-field
                      v-model="evalItem.city"
                      @keyup.enter="save"
                      label="City"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2 md2>
                    <v-text-field
                      v-model="evalItem.state"
                      @keyup.enter="save"
                      label="ST"
                      mask="AA"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md5>
                    <v-text-field
                      v-model="evalItem.zip"
                      @keyup.enter="save"
                      label="Zipcode"
                      mask="#####"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="evalItem.VendorContactId"
                  :items="contactList"
                  item-text="name"
                  item-value="value"
                  label="Contact"
                ></v-select>
              </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogInvoiceEdit" max-width="800px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeThisEval">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit Invoice</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout v-if="editTop" class="pb-3" row wrap>
                <v-flex xs6>
                  Invoice No. {{ evalItem.id}}
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu2"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="evalItem.formattedDate"
                      label="Date"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      v-model="evalItem.date"
                      no-title
                      @input="menu2 = false"
                      @change="evalItem.formattedDate = formatDate(evalItem.date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.name"
                    @keyup.enter="save"
                    label="Company Name"
                    :rules="[v => !!v || 'Lasty Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="evalItem.address"
                    @keyup.enter="save"
                    label="Address"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="evalItem.city"
                        @keyup.enter="save"
                        label="City"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="evalItem.state"
                        @keyup.enter="save"
                        label="ST"
                        mask="AA"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="evalItem.zip"
                        @keyup.enter="save"
                        label="Zipcode"
                        mask="#####"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="evalItem.VendorContactId"
                    :items="contactList"
                    item-text="name"
                    item-value="value"
                    label="Contact"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-textarea
                    v-model="evalItem.notes"
                    label="Notes"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12 sm4 class="text-xs-right">
                  <v-btn color="primary" @click="save">Save</v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-else class="pb-3" row wrap>
                <v-flex xs6>
                  Invoice No. {{ evalItem.id}}
                </v-flex>
                <v-flex xs6 class="text-xs-right">
                  Date {{ formattedDate }}
              </v-flex>
              <v-flex xs12>
                {{ evalItem.name }}<br />
                {{ evalItem.address}}<br />
                {{ evalItem.city}} {{ evalItem.state}} {{ evalItem.zip}}<br />
                {{ evalItem.contactName }}<br />
                {{ evalItem.contactPhone }}<br />
                {{ evalItem.contactEmail }}
              </v-flex>
              <v-flex xs12 sm8>
                Note {{ evalItem.notes }}
              </v-flex>
              <v-flex xs12 sm4 class="text-xs-right">
                <v-btn color="primary" @click="editTop = !editTop">Edit</v-btn>
              </v-flex>
            </v-layout>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12 px-0 mx-0>
                <v-card-text px-0 mx-0>
                  <v-data-table
                    :headers="itemHeaders"
                    :items="evalItem.VendorAccountingDetails"
                    hide-actions
                    class="elevation-1"
                    px-0 mx-0
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.item.description }}</td>
                      <td class="text-xs-center">{{ props.item.quantity }}</td>
                      <td class="text-xs-center">{{ props.item.priceDisplay }}</td>
                      <td class="text-xs-right">{{ props.item.totalDisplay }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon @click="deleteDetail(props.item)" color="red">block</v-icon>
                      </td>
                    </template>
                    <template v-slot:footer>
                      <td>
                        <v-btn color="primary" @click="addDetail(evalItem)">Add Detail</v-btn>
                      </td>
                      <td class="text-xs-right" :colspan="itemHeaders.length - 3">
                        <strong>Total</strong>
                      </td>
                      <td v-if="evalItem.grandTotal < 0" class="text-xs-right red--text">{{ evalItem.grandTotalDisplay }}</td>
                      <td  v-else class="text-xs-right">{{ evalItem.grandTotalDisplay }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="evalItem.status === 'Void'" color="green" @click="voidInvoice(evalItem, 'Open')">UnVoid</v-btn>
            <v-btn v-else color="red" @click="voidInvoice(evalItem, 'Void')">Void</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="dialogDetailAdd" max-width="500px">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-card >
          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="closeDetail">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add Detail</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="edit" dark flat @click="updateItem">Udate</v-btn> -->
              <v-btn dark flat @click="saveDetail">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout class="pb-3" row wrap>
                <v-flex xs12>
                  <v-select
                    v-model="pricingId"
                    :items="priceList"
                    item-text="name"
                    item-value="id"
                    label="Pricing"
                    @change="addPricing(pricingId)"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.description"
                    @keyup.enter="save"
                    label="Description"
                    :rules="[v => !!v || 'Description is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="editedItem.quantity"
                    @keyup.enter="save"
                    label="Quanity"
                    @change="updatePricing()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="editedItem.price"
                    @keyup.enter="save"
                    label="Price"
                    prefix="$"
                    @change="updatePricing()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                    v-model="editedItem.amountDisplay"
                    label="Amount"
                    readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import XLSX from 'xlsx'
import moment from 'moment'
import Utilities from '@/services/Utilities'

export default {
  props: ['currentYear', 'item'],

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'Accounting List',
      menu1: false,
      menu2: false,
      formattedDate: '',
      valid: true,
      searchSelect: [],
      searchType: '',
      isAdmin: this.$store.state.isAdmin,
      dialogPayment: false,
      dialogInvoice: false,
      dialogInvoiceEdit: false,
      dialogDetailAdd: false,
      loading: false,
      isTableLoading: false,
      isMounted: false,
      editTop: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      boothHeaders: [
        {text: 'Invoice #', align: 'center', sortable: false, value: 'id'},
        {text: 'Date', align: 'center', sortable: false, value: 'date'},
        {text: 'Type', align: 'center', sortable: false, value: 'type'},
        {text: 'Detail', align: 'center', sortable: false, value: 'detail'},
        {text: 'Amount', align: 'center', sortable: false, value: 'amount'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      itemHeaders: [
        {text: 'Description', align: 'center', sortable: false, value: 'description'},
        {text: 'Quantity', align: 'center', sortable: false, value: 'quantiy'},
        {text: 'Amount', align: 'center', sortable: false, value: 'amount'},
        {text: 'Total', align: 'center', sortable: false, value: 'total'},
        {text: 'Del', align: 'center', sortable: false, value: 'id'}
      ],
      grandTotal: 0,
      grandTotalDisplay: 0,
      rows: [],
      contacts: [],
      contactList: [],
      paymentList: [
        {id: null, name: 'Payment'},
        {id: 9, name: 'Deposit'},
        {id: 23, name: 'Sales Tax'}
      ],
      paymentMode: [
        {id: 'Cash', name: 'Cash'},
        {id: 'Check', name: 'Check'},
        {id: 'Credit Card', name: 'Credit Card'}
      ],
      editedItem: {},
      evalItem: {},
      showEvalForm: false,
      prices: [],
      priceList: [],
      invoiceItems: [],
      pricingId: 0
    }
  },

  created () {
    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getAccounting()
    this.getContacts()

    this.loading = false
    // console.log(this.$refs)
  },

  mounted () {
    this.isMounted = true
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    newItem () {
      this.evalItem = {}
      this.evalItem.date = moment().format('YYYY-MM-DD')
      this.formattedDate = moment().format('MM/DD/YYYY')
      this.evalItem.name = this.item.name
      this.evalItem.address = this.item.address
      this.evalItem.city = this.item.city
      this.evalItem.state = this.item.state
      this.evalItem.zip = this.item.zip
      this.dialogInvoice = true
    },

    newPayment () {
      this.evalItem = {}
      this.evalItem.date = moment().format('YYYY-MM-DD')
      this.formattedDate = moment().format('MM/DD/YYYY')
      this.evalItem.paymentType = null
      this.evalItem.name = this.item.name
      this.evalItem.address = this.item.address
      this.evalItem.city = this.item.city
      this.evalItem.state = this.item.state
      this.evalItem.zip = this.item.zip
      this.evalItem.emailReceipt = false
      this.evalItem.email = this.item.VendorContacts[0].email
      this.dialogPayment = true
    },

    editItem (props) {
      this.getPrices()
      this.formattedDate = moment(props.date).format('MM/DD/YYYY')

      let grandTotal = 0

      for (let i in props.VendorAccountingDetails) {
        let total = props.VendorAccountingDetails[i].quantity * Number(props.VendorAccountingDetails[i].price)
        grandTotal = grandTotal + total

        let totalDisplay = total.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
        let priceDisplay = Number(props.VendorAccountingDetails[i].price).toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        props.VendorAccountingDetails[i].total = total
        props.VendorAccountingDetails[i].priceDisplay = priceDisplay
        props.VendorAccountingDetails[i].totalDisplay = totalDisplay
      }

      props.grandTotal = grandTotal
      props.grandTotalDisplay = grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

      this.evalItem = props
      this.dialogInvoiceEdit = true
    },

    addDetail (props) {
      this.evalItem = props
      this.dialogDetailAdd = true
    },

    addPricing (item) {
      const priceList = this.priceList.find(({ id }) => id === item)
      console.log(priceList)

      let item1 = item.toLocaleString()
      if (item1.indexOf('-') !== -1) {
        let myArray = item1.split('-')
        item = Number(myArray[0])
      }

      const price = this.prices.find(({ id }) => id === item)
      console.log(price)
      this.editedItem.description = priceList.name
      this.editedItem.price = price.price

      if (priceList.quantity) {
        this.editedItem.quantity = priceList.quantity
      } else {
        this.editedItem.quantity = 1
      }

      this.editedItem.amount = Number(this.editedItem.price) * this.editedItem.quantity
      this.editedItem.amountDisplay = this.editedItem.amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
    },

    updatePricing () {
      console.log('test')
      let amount = Number(this.editedItem.price) * Number(this.editedItem.quantity)
      this.editedItem.amount = amount
      console.log(amount)
      this.editedItem.amountDisplay = amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
      console.log(this.editedItem.amountDisplay)
    },

    save () {
      if (this.evalItem.id > 0) {
        this.updateItem(this.editedItem)
      } else {
        this.addItem(this.editedItem)
      }
    },

    async addItem () {
      try {
        const contact = this.contacts.find(({ id }) => id === this.evalItem.VendorContactId)

        this.evalItem.VendorCompanyId = this.item.id
        this.evalItem.type = 'Invoice'
        this.evalItem.status = 'Open'
        this.evalItem.createdBy = this.myId
        this.evalItem.contactName = contact.fullName
        this.evalItem.contactPhone = contact.mobile
        this.evalItem.contactEmail = contact.email
        this.evalItem.year = this.currentYear
        console.log(this.evalItem)

        const response = await Api().post('invoice', this.evalItem)
        let invoice = response.data.invoice
        invoice.formattedDate = this.formatDate(invoice.date)

        this.rows.push(invoice)
        this.editItem(invoice)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async updateItem () {
      try {
        const contact = this.contacts.find(({ id }) => id === this.evalItem.VendorContactId)

        this.evalItem.createdBy = this.myId
        this.evalItem.contactName = contact.fullName
        this.evalItem.contactPhone = contact.mobile
        this.evalItem.contactEmail = contact.email
        console.log(this.evalItem)

        const response = await Api().put('invoice/' + this.evalItem.id, this.evalItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async savePayment () {
      try {
        this.evalItem.VendorCompanyId = this.item.id
        this.evalItem.type = 'Payment'
        this.evalItem.status = 'Open'
        this.evalItem.createdBy = this.myId
        this.evalItem.year = this.currentYear
        this.evalItem.payType = this.evalItem.paymentMode
        console.log(this.evalItem)

        const response = await Api().post('payment', this.evalItem)
        let payment = response.data.payment
        console.log('Payment', payment)
        payment.formattedDate = this.formatDate(payment.date)
        payment.amount = Number(payment.amount)
        payment.amountDisplay = payment.amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.grandTotal = this.grandTotal - Number(payment.amount)
        console.log(this.grandTotal, this.grandTotal, Number(payment.amount))
        this.grandTotalDisplay = this.grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.rows.push(payment)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async saveDetail () {
      try {
        this.editedItem.VendorAccountingId = this.evalItem.id
        this.editedItem.updatedBy = this.myId

        const response = await Api().post('invoice_detail', this.editedItem)
        const invoiceDetail = response.data.invoiceDetail

        let grandTotal = this.evalItem.grandTotal
        let price = Number(invoiceDetail.price)
        let quantity = Number(invoiceDetail.quantity)

        let total = price * quantity
        invoiceDetail.total = total
        invoiceDetail.priceDisplay = price.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
        invoiceDetail.totalDisplay = total.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        grandTotal = grandTotal + total

        this.evalItem.grandTotal = grandTotal
        this.evalItem.grandTotalDisplay = grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        if (!this.evalItem.VendorAccountingDetails) {
          this.evalItem.VendorAccountingDetails = []
        }

        this.evalItem.VendorAccountingDetails.push(invoiceDetail)

        this.getAccounting()
        this.closeDetail()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deleteDetail (item) {
      let r = confirm('Are you sure you want to remove this item?')

      if (r === true) {
        try {
          console.log(item)
          const response = await Api().delete('invoice_detail/' + item.id)

          this.evalItem.VendorAccountingDetails.splice(this.evalItem.VendorAccountingDetails.indexOf(item), 1)
          this.evalItem.VendorAccountingDetails = [...this.evalItem.VendorAccountingDetails]

          let grandTotal = this.evalItem.grandTotal
          let price = Number(item.price)
          let quantity = Number(item.quantity)

          let total = price * quantity
          grandTotal = grandTotal - total

          this.evalItem.grandTotal = grandTotal
          this.evalItem.grandTotalDisplay = grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

          this.getAccounting()

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    async voidInvoice (item, text) {
      try {
        item.updatedBy = this.myId
        item.status = text
        const response = await Api().put('invoice/' + item.id, item)
        this.getAccounting()
        this.closeThisEval()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async voidPayment (item, text) {
      try {
        item.updatedBy = this.myId
        item.status = text
        console.log(item)
        const response = await Api().put('payments/' + item.id, item)
        this.getAccounting()

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getAccounting () {
      try {
        console.log('test')
        const response = await Api().get('accounting/' + this.item.id + '/' + this.currentYear)

        let rows = response.data
        console.log('test', rows)

        let amount = 0
        let grandTotal = 0
        for (let i in rows) {
          rows[i].formattedDate = moment(rows[i].date).format('MM/DD/YYYY')

          if (rows[i].status === 'Void') {
            // rows[i].description = '** VOID **'
            amount = 0
          } else {
            if (rows[i].VendorAccountingDetails.length > 0) {
              amount = 0
              // if (rows[i].status === 'Void') {
              //   rows[i].description = '** VOID **'
              // } else {
              for (let j in rows[i].VendorAccountingDetails) {
                console.log(rows[i].VendorAccountingDetails[j])
                amount = amount + rows[i].VendorAccountingDetails[j].quantity * rows[i].VendorAccountingDetails[j].price
              }
              // }
            } else {
              // if (rows[i].status === 'Void') {
              //   rows[i].description = '** VOID **'
              //   amount = 0
              // } else {
              rows[i].description = ''
              if (rows[i].paymentType === 9) {
                rows[i].description = '** DEPOSIT ** - '
              } else if (rows[i].paymentType === 23) {
                rows[i].description = '** SALES Tax ** - '
              }

              rows[i].description = rows[i].description + rows[i].payType

              if (rows[i].cardNumber) {
                rows[i].description = rows[i].description + ' ' + rows[i].cardNumber
              }

              amount = Number(rows[i].amount) * -1
              // }
            }
          }

          grandTotal = grandTotal + amount
          // console.log(grandTotal)
          rows[i].amount = amount
          rows[i].amountDisplay = amount.toLocaleString('en-US', {style: 'currency', currency: 'USD'})
        }

        this.grandTotal = grandTotal
        this.grandTotalDisplay = grandTotal.toLocaleString('en-US', {style: 'currency', currency: 'USD'})

        this.rows = rows

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getContacts () {
      try {
        const response = await Api().get('vendor_contacts/' + this.item.id)

        this.contacts = response.data

        let contact = {}
        let contactList = []
        for (let i in this.contacts) {
          contact.value = this.contacts[i].id
          contact.name = this.contacts[i].fullName + ' (' + this.contacts[i].type + ')'

          contactList.push(contact)
          contact = {}
        }
        this.contactList = contactList

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getPrices () {
      try {
        const response = await Api().get('/prices/')

        this.prices = response.data
        let booths = this.item.VendorBooths

        let price = {}

        for (let i in booths) {
          const boothPrice = this.prices.filter(({ location }) => location === booths[i].location)
          for (let j in boothPrice) {
            price.id = boothPrice[j].id + '-' + booths[i].id
            price.name = 'Booth #' + booths[i].boothNumber + ' - ' + boothPrice[j].description
            price.quantity = booths[i].area
            this.priceList.push(price)
            price = {}
          }
        }

        const allBooths = this.prices.filter(({ location }) => location === 'All')

        for (let k in allBooths) {
          price.id = allBooths[k].id
          price.name = allBooths[k].description
          this.priceList.push(price)
          price = {}
        }

        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async sendStatement () {
      try {
        let statement = {}

        statement.date = moment().format('MM/DD/YYYY')
        statement.item = this.item
        statement.rows = this.rows
        console.log(statement)

        const response = await Api().post('send_statement', statement)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    onExport () {
      this.printMembers = this.rows.map(a => ({
        'Name': a.name,
        'Address': a.address,
        'City': a.city,
        'State': a.state,
        'Zip': a.zip,
        'Primary Phone': a.primaryPhone,
        'Secondayr Phone': a.secondaryPhone,
        'Email': a.email,
        'Age': a.age,
        'Height': a.height,
        'Weight': a.weight,
        'Parents': a.parents,
        'Notes': a.notes
      }))

      let membersWS = XLSX.utils.json_to_sheet(this.printMembers)

      let wb = XLSX.utils.book_new()

      if (!wb.Props) { wb.Props = {} }
      wb.Props.Title = 'Insert Title Here'

      XLSX.utils.book_append_sheet(wb, membersWS, this.committeeHeader.committeeCode)

      XLSX.writeFile(wb, this.currentYear + ' Mutton Busters.xlsx')
    },

    closeThisEval (item) {
      this.editTop = false
      this.evalItem = {}
      this.editedItem = {}
      this.dialogInvoice = false
      this.dialogPayment = false
      this.dialogInvoiceEdit = false
      this.dialogDetailAdd = false
    },

    closeDetail (item) {
      this.pricingId = 0
      this.dialogDetailAdd = false
      this.editedItem = {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/AccountingList.vue